'use client';
import { colors } from '@/styles';
import { ControlProps, MenuProps } from 'react-select';
import { CSSObject } from '@emotion/serialize';

const controlStyles = (base: CSSObject, state: ControlProps): CSSObject => ({
  ...base,
  boxShadow: 'none',
  backgroundColor: colors.secondary.lightGray1,
  '&:hover': { border: `1px solid ${colors.secondary.lightGray3}` },
});

const menuStyles = (base: CSSObject, state: MenuProps): CSSObject => ({
  ...base,
  zIndex: 99,
  width: 'max-content',
  overflow: 'hidden',
});

export default { controlStyles, menuStyles };
